import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'core/userContext';
import { useBillingQueryContext } from '../../contexts';
import {
  CATALOG_TOTAL_METRIC,
  LOOKUP_REFERENCES,
  COLLECTION_REFERENCES,
  PRODUCT_RECOMMENDATIONS,
} from '../../constants';
import { createColumns, createRows, queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { PageActions } from './PageActions';
import { createRowCell } from './TableCell';

export const TEXT = {
  PAGE_TITLE: 'Catalog usage',
};

export const CatalogUsage = () => {
  const { ProductRecommendations } = useSelector(selectFeatureFlags);
  const { projectIds, pickManyProjectMetrics, pickManyOrgMetrics, isLoading } =
    useBillingQueryContext();
  const { search } = useLocation();

  useEffect(() => {
    window.scrollTo();
  }, []);

  const metricNames = [
    LOOKUP_REFERENCES,
    COLLECTION_REFERENCES,
    ...(ProductRecommendations ? [PRODUCT_RECOMMENDATIONS] : []),
  ];

  const metricsByProjectId = projectIds.reduce((acc, projectId) => {
    const metrics = pickManyProjectMetrics(projectId, metricNames);
    const totalValue = metrics.reduce((sum, metric) => sum + metric.value, 0);
    const catalogTotalMetric = {
      metricName: CATALOG_TOTAL_METRIC,
      value: totalValue,
    };
    return { [projectId]: [...metrics, catalogTotalMetric], ...acc };
  }, {});

  const orgMetrics = pickManyOrgMetrics(metricNames);

  const orgTotal = orgMetrics.reduce((sum, metric) => sum + metric.value, 0);
  const orgMetricsWithTotal = [
    { metricName: CATALOG_TOTAL_METRIC, value: orgTotal },
    ...orgMetrics,
  ];

  const rows = createRows(orgMetricsWithTotal, metricsByProjectId);
  const columns = createColumns(metricsByProjectId);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={{
        content: 'Usage and Billing',
        href: `/payments/info${search}`,
      }}
      pageTitle={TEXT.PAGE_TITLE}
      pageActions={<PageActions />}
      isLoading={isLoading}
      queryByFn={queryByFn}
    />
  );
};
